export class NaturaRichiedenteRequestDTO {
	codiceTipoDeposito: string;
}